export default __webpack_public_path__ + "static/hellodeary-icon-bf1252e7116a5a93704d768a23793f9b.png";